module.exports = __webpack_public_path__ + "static/media/46_Shoaei_webfinal.de5df0a3.jpg";